<template>
  <v-container style="max-width:1200px" class="pt-0">
    <ASearchForm
      :modelName="modelName"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sort-by="'listOrder'"
      :sort-desc="false"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      :moveActions="hasEditPermission"
      @click:edit="onEdit"
      @click:delete="onDelete"
      @click:move="move"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="modelName"
      :model="model"
      :updateOnlyChanged="true"
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import snackbar from "../mixins/snackbar";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import crudFuncsMixin from "../mixins/CRUDFuncs";
import PermissionsHelper from "../mixins/PermissionsHelper";
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";

export default {
  name: "MirrorZones",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin, PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "mirrorzones",
      modelName: "Mirror Zone",
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "List Order", value: "listOrder" },
        { text: "Location", value: "locationName" },
        { text: "Contract", value: "contractName" }
      ],
      apiParams: {},
      formMeta: [
        {
          type: "text",
          label: "Name*",
          queryParam: "name",
          rules: [
            v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
          ],
          value: "",
          updatable: true
        },
        {
          type: "text",
          label: "Description",
          queryParam: "description",
          rules: [],
          value: "",
          updatable: true
        },
        {
            type: "dropdown",
            model: "locations",
            label: "Location*",
            queryParam: "locationId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "dropdown",
            model: "contracts",
            label: "Contract*",
            queryParam: "contractId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
      ]
    };
  },
  updated() {
    this.load();
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>